import { Trans } from 'react-i18next';
import { Link, Text } from '@tiendanube/components';
import { FEATURE_ONLY_NUVEM_PAGO } from 'App/features';
import { Stack } from 'commons/components';
import { useGoToPlans, useStatusFeatureByKey } from 'domains/Auth/hooks';
import { ModalConfirmationWithAuth } from 'domains/AuthenticationFactor';
import useTranslationPayments from 'domains/Payments/useTranslationPayments';

const TRANSLATE_PREFIX = 'paymentProvider.disablePagoNubeModal';

interface DisablePagoNubeModalProps {
  onCancel: () => void;
  onConfirm: () => void;
}

function DisablePagoNubeModal({
  onCancel,
  onConfirm,
}: DisablePagoNubeModalProps): JSX.Element {
  const t = useTranslationPayments(TRANSLATE_PREFIX);
  const { goToPlans } = useGoToPlans();

  const { maxUse } = useStatusFeatureByKey(FEATURE_ONLY_NUVEM_PAGO);

  const plan = maxUse === 1 ? 'freemium' : 'others';

  const title = t(`${plan}.title`);
  const textFirstKey = `${plan}.first`;
  const textSecond = t(`${plan}.second`);
  const confirm = t(`${plan}.confirm`);
  const cancel = t(`${plan}.cancel`);

  const handleCancel = plan === 'freemium' ? goToPlans : onCancel;
  const handleConfirm = plan === 'freemium' ? onConfirm : onConfirm;

  const text = (
    <Stack column align="flex-start">
      <Text>
        <Trans
          t={t}
          i18nKey={textFirstKey}
          components={{
            PlanLink: <Link appearance="primary" onClick={goToPlans} />,
            strong: <strong />,
          }}
        />
      </Text>
      <Text>{textSecond}</Text>
    </Stack>
  );

  return (
    <ModalConfirmationWithAuth
      title={title}
      text={text}
      labelConfirm={confirm}
      labelCancel={cancel}
      onClose={onCancel}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );
}

export default DisablePagoNubeModal;
